import {
    RegionsEnum, SensorAmFragmentDoc, SensorApFragmentDoc, SensorEuFragmentDoc,
    SensorsFilterPageAmDocument,
    SensorsFilterPageApDocument,
    SensorsFilterPageDocument,
    SensorsFilterPageEuDocument,
    SensorsFilterPagePrimaryDocument,
    SensorsFilterPageSecondaryAmDocument,
    SensorsFilterPageSecondaryApDocument,
    SensorsFilterPageSecondaryEuDocument,
    SensorsListAmDocument,
    SensorsListAmQuery,
    SensorsListAmQueryVariables,
    SensorsListApDocument,
    SensorsListApQuery,
    SensorsListApQueryVariables,
    SensorsListEuDocument,
    SensorsListEuQuery,
    SensorsListEuQueryVariables,
} from 'src/generated/operations.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { DocumentNode } from 'graphql/language/ast';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { generateFiltersConfig } from 'src/utils/generateFiltersConfig.ts';
import { generateItemsConfig } from 'src/utils/generateOrderItems.ts';

export type SensorsPageData = Omit<SensorsListEuQuery | SensorsListApQuery | SensorsListAmQuery, '__typename'>;
export type SensorsPageVariables = Omit<
SensorsListEuQueryVariables | SensorsListApQueryVariables | SensorsListAmQueryVariables, '__typename'
>;
export type SensorProduct = SensorsPageData['list']['results']['0'];

export type SensorsPageConfig = {
    query: DocumentNode;
    filterConfig: FilterConfig;
    orderItemsConfig: FilterConfig;
    queryPrimary: DocumentNode;
    genericFilterQuery: DocumentNode;
    filterConfigPrimary: FilterConfig;
    filterConfigSecondary: FilterConfig;
}

export const getSensorsPageConfig = (region: RegionsEnum): SensorsPageConfig | null => {
    const primaryFilterConfig = generateFiltersConfig(SensorsFilterPagePrimaryDocument, 'sensorsValues');
    const queryPrimary = removeDuplicateFragments(SensorsFilterPagePrimaryDocument);
    const genericFilterQuery = removeDuplicateFragments(SensorsFilterPageDocument);

    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(SensorsListEuDocument),
            filterConfig: generateFiltersConfig(SensorsFilterPageEuDocument, 'sensorsValues'),
            orderItemsConfig: generateItemsConfig(SensorEuFragmentDoc),
            genericFilterQuery,
            queryPrimary,
            filterConfigPrimary: primaryFilterConfig,
            filterConfigSecondary: generateFiltersConfig(SensorsFilterPageSecondaryEuDocument, 'sensorsValues'),
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(SensorsListApDocument),
            filterConfig: generateFiltersConfig(SensorsFilterPageApDocument, 'sensorsValues'),
            orderItemsConfig: generateItemsConfig(SensorApFragmentDoc),
            genericFilterQuery,
            queryPrimary,
            filterConfigPrimary: primaryFilterConfig,
            filterConfigSecondary: generateFiltersConfig(SensorsFilterPageSecondaryApDocument, 'sensorsValues'),
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(SensorsListAmDocument),
            filterConfig: generateFiltersConfig(SensorsFilterPageAmDocument, 'sensorsValues'),
            orderItemsConfig: generateItemsConfig(SensorAmFragmentDoc),
            genericFilterQuery,
            queryPrimary,
            filterConfigPrimary: primaryFilterConfig,
            filterConfigSecondary: generateFiltersConfig(SensorsFilterPageSecondaryAmDocument, 'sensorsValues'),
        };
    }
    return null;
};
